// NPM Imports
// Quote Context
// Component Imports
// JS Imports
// Asset Imports

export default function SpacerThick({ order = -99 }) {
   return (
      <div className='row-spacer-bhr2' style={{ order: order }}>
         &nbsp;
      </div>
   )
}
